import { ConnectionNames } from "../../Contracts";
import { ConfigStore, storeToken, tokenRenewHandler } from "../../Common";
const handlers = [
    tokenRenewHandler(ConnectionNames.sports),
    tokenRenewHandler(ConnectionNames.openBets),
    tokenRenewHandler(ConnectionNames.betslip, true),
    tokenRenewHandler(ConnectionNames.tournaments, true),
];
export function onTokenRenew(payload) {
    const prevToken = ConfigStore.config.connections.jwt;
    const nextToken = payload.data[0].token;
    storeToken(nextToken);
    handlers.forEach(handler => {
        handler(prevToken, nextToken);
    });
}
//# sourceMappingURL=OnTokenRenew.js.map